import React from "react";
import styled from "styled-components";

import { theme } from "../../styles/theme";
import { PlusIconSmall } from "../svg/plus-icon";

type ButtonProps = {
  disabled?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  type?: "button" | "submit" | "reset";
};

export default function AddButton(props: ButtonProps) {
  const { type = "button", onClick, children, disabled } = props;
  return (
    <StyledButton type={type} onClick={onClick} disabled={disabled}>
      <PlusCircle>
        <PlusIconSmall />
      </PlusCircle>
      {children}
    </StyledButton>
  );
}

/* A dashed outline, so the zone reads as a place to drop something into, not as a filled button. */
const StyledButton = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 16px 20px;
  border: 1px dashed ${theme.colors.blue[700]};
  border-radius: 8px;
  background-color: transparent;
  cursor: pointer;
  ${theme.text};
  font-size: 16px;
  line-height: 22px;
  color: ${theme.colors.blue[800]};

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:hover {
    background-color: ${theme.colors.blue[100]};
  }
`;

const PlusCircle = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${theme.colors.gray[100]};

  path {
    fill: ${theme.colors.blue[700]};
  }
`;
